import React, { Component } from 'react'
import { IntlProvider, injectIntl } from 'react-intl'
import createAxios from 'utils/axios'

// Components
import Layout from '../application/layout'
import ServerError from './server_error'
import NotFound from './not_found'

class ExceptionApp extends Component {
  componentDidMount() {
    this.axios = createAxios({
      intl: this.props.intl,
      makePartnersRedirect: this.props.makePartnersRedirect,
    })
  }

  t(id) {
    return this.props.intl.formatMessage({ id })
  }

  renderComponent() {
    const props = {
      locale: this.props.locale,
      intlLocale: this.props.intlLocale
    }

    switch (this.props.status_code) {
      case 404:
        return <NotFound {...props} />
      default:
        return <ServerError {...props} />
    }
  }

  handleLogoutBtn(e) {
    e.preventDefault()

    this.axios.delete('/logout').then(() => {
      window.location.href = `/${this.props.locale}/login`
    })
  }

  render() {
    return (
      <IntlProvider locale={this.props.intlLocale} messages={this.props.messages}>
        <Layout
          locale={this.props.locale}
          intlLocale={this.props.intlLocale}
          messages={this.props.messages}
          region={this.props.region}>

          {this.renderComponent()}

          {!this.props.isOnnet && this.props.logged_in && (<div style={{ textAlign: 'center' }}>
            <button onClick={this.handleLogoutBtn.bind(this)} className="btn btn-danger">{this.t('LogoutButton.Logout')}</button>
          </div>)}
        </Layout>
      </IntlProvider>
    )
  }
}

export default injectIntl(ExceptionApp)



// WEBPACK FOOTER //
// ./app/javascript/components/exception/app.js